/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as MainRouteImport } from './routes/_main'
import { Route as DocsRouteImport } from './routes/_docs'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as OnboardingConnectAccountRouteImport } from './routes/_onboarding/connect-account'
import { Route as MainUploadProductsRouteImport } from './routes/_main/upload-products'
import { Route as MainDemandPredictionRouteImport } from './routes/_main/demand-prediction'
import { Route as MainAboutRouteImport } from './routes/_main/about'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as MainWhatsappMonitoringIndexRouteImport } from './routes/_main/whatsapp-monitoring.index'
import { Route as MainSettingsIndexRouteImport } from './routes/_main/settings/index'
import { Route as MainSalesAgentIndexRouteImport } from './routes/_main/sales-agent/index'
import { Route as MainReportsIndexRouteImport } from './routes/_main/reports/index'
import { Route as MainReconciliationIndexRouteImport } from './routes/_main/reconciliation/index'
import { Route as MainProductsIndexRouteImport } from './routes/_main/products/index'
import { Route as MainOrdersIndexRouteImport } from './routes/_main/orders/index'
import { Route as MainCustomersIndexRouteImport } from './routes/_main/customers/index'
import { Route as MainWhatsappMonitoringGroupIdRouteImport } from './routes/_main/whatsapp-monitoring.$groupId'
import { Route as MainReportsUomMismatchRouteImport } from './routes/_main/reports/uom-mismatch'
import { Route as MainReportsSalesByCustomerRouteImport } from './routes/_main/reports/sales-by-customer'
import { Route as MainReportsProductMixRouteImport } from './routes/_main/reports/product-mix'
import { Route as MainReportsOosRouteImport } from './routes/_main/reports/oos'
import { Route as MainReconciliationNewRouteImport } from './routes/_main/reconciliation/new'
import { Route as MainOrdersUploadFailedRouteImport } from './routes/_main/orders/upload-failed'
import { Route as MainOrdersUploadRouteImport } from './routes/_main/orders/upload'
import { Route as MainOrdersOrderIdRouteImport } from './routes/_main/orders/$orderId'
import { Route as MainErrorsSessionExpiredRouteImport } from './routes/_main/errors.session-expired'
import { Route as MainErrors404RouteImport } from './routes/_main/errors.404'
import { Route as DocsDocsTosRouteImport } from './routes/_docs/docs.tos'
import { Route as DocsDocsPrivacyPolicyRouteImport } from './routes/_docs/docs.privacy-policy'
import { Route as MainReconciliationRunIdIndexRouteImport } from './routes/_main/reconciliation/$runId/index'
import { Route as MainProductsUploadIndexRouteImport } from './routes/_main/products/upload/index'
import { Route as MainProductsAllocationIndexRouteImport } from './routes/_main/products/allocation/index'
import { Route as MainSalesAgentAgentKeySessionIdRouteImport } from './routes/_main/sales-agent/$agentKey/$sessionId'
import { Route as MainProductsAllocationUploadRouteImport } from './routes/_main/products/allocation/upload'
import { Route as MainOrdersUploadSummaryRequestIdRouteImport } from './routes/_main/orders/upload-summary.$requestId'
import { Route as MainOrdersGenerateInvoiceOrderIdRouteImport } from './routes/_main/orders/generate-invoice.$orderId'
import { Route as MainProductsUploadReviewSessionIdRouteImport } from './routes/_main/products/upload/review.$sessionId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/_docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)
const OnboardingConnectAccountRoute =
  OnboardingConnectAccountRouteImport.update({
    id: '/connect-account',
    path: '/connect-account',
    getParentRoute: () => OnboardingRoute,
  } as any)
const MainUploadProductsRoute = MainUploadProductsRouteImport.update({
  id: '/upload-products',
  path: '/upload-products',
  getParentRoute: () => MainRoute,
} as any)
const MainDemandPredictionRoute = MainDemandPredictionRouteImport.update({
  id: '/demand-prediction',
  path: '/demand-prediction',
  getParentRoute: () => MainRoute,
} as any)
const MainAboutRoute = MainAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MainRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const MainWhatsappMonitoringIndexRoute =
  MainWhatsappMonitoringIndexRouteImport.update({
    id: '/whatsapp-monitoring/',
    path: '/whatsapp-monitoring/',
    getParentRoute: () => MainRoute,
  } as any)
const MainSettingsIndexRoute = MainSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => MainRoute,
} as any)
const MainSalesAgentIndexRoute = MainSalesAgentIndexRouteImport.update({
  id: '/sales-agent/',
  path: '/sales-agent/',
  getParentRoute: () => MainRoute,
} as any)
const MainReportsIndexRoute = MainReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => MainRoute,
} as any)
const MainReconciliationIndexRoute = MainReconciliationIndexRouteImport.update({
  id: '/reconciliation/',
  path: '/reconciliation/',
  getParentRoute: () => MainRoute,
} as any)
const MainProductsIndexRoute = MainProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersIndexRoute = MainOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => MainRoute,
} as any)
const MainCustomersIndexRoute = MainCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => MainRoute,
} as any)
const MainWhatsappMonitoringGroupIdRoute =
  MainWhatsappMonitoringGroupIdRouteImport.update({
    id: '/whatsapp-monitoring/$groupId',
    path: '/whatsapp-monitoring/$groupId',
    getParentRoute: () => MainRoute,
  } as any)
const MainReportsUomMismatchRoute = MainReportsUomMismatchRouteImport.update({
  id: '/reports/uom-mismatch',
  path: '/reports/uom-mismatch',
  getParentRoute: () => MainRoute,
} as any)
const MainReportsSalesByCustomerRoute =
  MainReportsSalesByCustomerRouteImport.update({
    id: '/reports/sales-by-customer',
    path: '/reports/sales-by-customer',
    getParentRoute: () => MainRoute,
  } as any)
const MainReportsProductMixRoute = MainReportsProductMixRouteImport.update({
  id: '/reports/product-mix',
  path: '/reports/product-mix',
  getParentRoute: () => MainRoute,
} as any)
const MainReportsOosRoute = MainReportsOosRouteImport.update({
  id: '/reports/oos',
  path: '/reports/oos',
  getParentRoute: () => MainRoute,
} as any)
const MainReconciliationNewRoute = MainReconciliationNewRouteImport.update({
  id: '/reconciliation/new',
  path: '/reconciliation/new',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersUploadFailedRoute = MainOrdersUploadFailedRouteImport.update({
  id: '/orders/upload-failed',
  path: '/orders/upload-failed',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersUploadRoute = MainOrdersUploadRouteImport.update({
  id: '/orders/upload',
  path: '/orders/upload',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersOrderIdRoute = MainOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => MainRoute,
} as any)
const MainErrorsSessionExpiredRoute =
  MainErrorsSessionExpiredRouteImport.update({
    id: '/errors/session-expired',
    path: '/errors/session-expired',
    getParentRoute: () => MainRoute,
  } as any)
const MainErrors404Route = MainErrors404RouteImport.update({
  id: '/errors/404',
  path: '/errors/404',
  getParentRoute: () => MainRoute,
} as any)
const DocsDocsTosRoute = DocsDocsTosRouteImport.update({
  id: '/docs/tos',
  path: '/docs/tos',
  getParentRoute: () => DocsRoute,
} as any)
const DocsDocsPrivacyPolicyRoute = DocsDocsPrivacyPolicyRouteImport.update({
  id: '/docs/privacy-policy',
  path: '/docs/privacy-policy',
  getParentRoute: () => DocsRoute,
} as any)
const MainReconciliationRunIdIndexRoute =
  MainReconciliationRunIdIndexRouteImport.update({
    id: '/reconciliation/$runId/',
    path: '/reconciliation/$runId/',
    getParentRoute: () => MainRoute,
  } as any)
const MainProductsUploadIndexRoute = MainProductsUploadIndexRouteImport.update({
  id: '/products/upload/',
  path: '/products/upload/',
  getParentRoute: () => MainRoute,
} as any)
const MainProductsAllocationIndexRoute =
  MainProductsAllocationIndexRouteImport.update({
    id: '/products/allocation/',
    path: '/products/allocation/',
    getParentRoute: () => MainRoute,
  } as any)
const MainSalesAgentAgentKeySessionIdRoute =
  MainSalesAgentAgentKeySessionIdRouteImport.update({
    id: '/sales-agent/$agentKey/$sessionId',
    path: '/sales-agent/$agentKey/$sessionId',
    getParentRoute: () => MainRoute,
  } as any)
const MainProductsAllocationUploadRoute =
  MainProductsAllocationUploadRouteImport.update({
    id: '/products/allocation/upload',
    path: '/products/allocation/upload',
    getParentRoute: () => MainRoute,
  } as any)
const MainOrdersUploadSummaryRequestIdRoute =
  MainOrdersUploadSummaryRequestIdRouteImport.update({
    id: '/orders/upload-summary/$requestId',
    path: '/orders/upload-summary/$requestId',
    getParentRoute: () => MainRoute,
  } as any)
const MainOrdersGenerateInvoiceOrderIdRoute =
  MainOrdersGenerateInvoiceOrderIdRouteImport.update({
    id: '/orders/generate-invoice/$orderId',
    path: '/orders/generate-invoice/$orderId',
    getParentRoute: () => MainRoute,
  } as any)
const MainProductsUploadReviewSessionIdRoute =
  MainProductsUploadReviewSessionIdRouteImport.update({
    id: '/products/upload/review/$sessionId',
    path: '/products/upload/review/$sessionId',
    getParentRoute: () => MainRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MainIndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/about': typeof MainAboutRoute
  '/demand-prediction': typeof MainDemandPredictionRoute
  '/upload-products': typeof MainUploadProductsRoute
  '/connect-account': typeof OnboardingConnectAccountRoute
  '/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/docs/tos': typeof DocsDocsTosRoute
  '/errors/404': typeof MainErrors404Route
  '/errors/session-expired': typeof MainErrorsSessionExpiredRoute
  '/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/orders/upload': typeof MainOrdersUploadRoute
  '/orders/upload-failed': typeof MainOrdersUploadFailedRoute
  '/reconciliation/new': typeof MainReconciliationNewRoute
  '/reports/oos': typeof MainReportsOosRoute
  '/reports/product-mix': typeof MainReportsProductMixRoute
  '/reports/sales-by-customer': typeof MainReportsSalesByCustomerRoute
  '/reports/uom-mismatch': typeof MainReportsUomMismatchRoute
  '/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/customers/': typeof MainCustomersIndexRoute
  '/orders/': typeof MainOrdersIndexRoute
  '/products/': typeof MainProductsIndexRoute
  '/reconciliation/': typeof MainReconciliationIndexRoute
  '/reports/': typeof MainReportsIndexRoute
  '/sales-agent/': typeof MainSalesAgentIndexRoute
  '/settings/': typeof MainSettingsIndexRoute
  '/whatsapp-monitoring/': typeof MainWhatsappMonitoringIndexRoute
  '/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/sales-agent/$agentKey/$sessionId': typeof MainSalesAgentAgentKeySessionIdRoute
  '/products/allocation/': typeof MainProductsAllocationIndexRoute
  '/products/upload/': typeof MainProductsUploadIndexRoute
  '/reconciliation/$runId/': typeof MainReconciliationRunIdIndexRoute
  '/products/upload/review/$sessionId': typeof MainProductsUploadReviewSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof MainIndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/about': typeof MainAboutRoute
  '/demand-prediction': typeof MainDemandPredictionRoute
  '/upload-products': typeof MainUploadProductsRoute
  '/connect-account': typeof OnboardingConnectAccountRoute
  '/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/docs/tos': typeof DocsDocsTosRoute
  '/errors/404': typeof MainErrors404Route
  '/errors/session-expired': typeof MainErrorsSessionExpiredRoute
  '/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/orders/upload': typeof MainOrdersUploadRoute
  '/orders/upload-failed': typeof MainOrdersUploadFailedRoute
  '/reconciliation/new': typeof MainReconciliationNewRoute
  '/reports/oos': typeof MainReportsOosRoute
  '/reports/product-mix': typeof MainReportsProductMixRoute
  '/reports/sales-by-customer': typeof MainReportsSalesByCustomerRoute
  '/reports/uom-mismatch': typeof MainReportsUomMismatchRoute
  '/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/customers': typeof MainCustomersIndexRoute
  '/orders': typeof MainOrdersIndexRoute
  '/products': typeof MainProductsIndexRoute
  '/reconciliation': typeof MainReconciliationIndexRoute
  '/reports': typeof MainReportsIndexRoute
  '/sales-agent': typeof MainSalesAgentIndexRoute
  '/settings': typeof MainSettingsIndexRoute
  '/whatsapp-monitoring': typeof MainWhatsappMonitoringIndexRoute
  '/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/sales-agent/$agentKey/$sessionId': typeof MainSalesAgentAgentKeySessionIdRoute
  '/products/allocation': typeof MainProductsAllocationIndexRoute
  '/products/upload': typeof MainProductsUploadIndexRoute
  '/reconciliation/$runId': typeof MainReconciliationRunIdIndexRoute
  '/products/upload/review/$sessionId': typeof MainProductsUploadReviewSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_docs': typeof DocsRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_main/about': typeof MainAboutRoute
  '/_main/demand-prediction': typeof MainDemandPredictionRoute
  '/_main/upload-products': typeof MainUploadProductsRoute
  '/_onboarding/connect-account': typeof OnboardingConnectAccountRoute
  '/_main/': typeof MainIndexRoute
  '/_docs/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/_docs/docs/tos': typeof DocsDocsTosRoute
  '/_main/errors/404': typeof MainErrors404Route
  '/_main/errors/session-expired': typeof MainErrorsSessionExpiredRoute
  '/_main/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/_main/orders/upload': typeof MainOrdersUploadRoute
  '/_main/orders/upload-failed': typeof MainOrdersUploadFailedRoute
  '/_main/reconciliation/new': typeof MainReconciliationNewRoute
  '/_main/reports/oos': typeof MainReportsOosRoute
  '/_main/reports/product-mix': typeof MainReportsProductMixRoute
  '/_main/reports/sales-by-customer': typeof MainReportsSalesByCustomerRoute
  '/_main/reports/uom-mismatch': typeof MainReportsUomMismatchRoute
  '/_main/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/_main/customers/': typeof MainCustomersIndexRoute
  '/_main/orders/': typeof MainOrdersIndexRoute
  '/_main/products/': typeof MainProductsIndexRoute
  '/_main/reconciliation/': typeof MainReconciliationIndexRoute
  '/_main/reports/': typeof MainReportsIndexRoute
  '/_main/sales-agent/': typeof MainSalesAgentIndexRoute
  '/_main/settings/': typeof MainSettingsIndexRoute
  '/_main/whatsapp-monitoring/': typeof MainWhatsappMonitoringIndexRoute
  '/_main/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/_main/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/_main/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/_main/sales-agent/$agentKey/$sessionId': typeof MainSalesAgentAgentKeySessionIdRoute
  '/_main/products/allocation/': typeof MainProductsAllocationIndexRoute
  '/_main/products/upload/': typeof MainProductsUploadIndexRoute
  '/_main/reconciliation/$runId/': typeof MainReconciliationRunIdIndexRoute
  '/_main/products/upload/review/$sessionId': typeof MainProductsUploadReviewSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/demand-prediction'
    | '/upload-products'
    | '/connect-account'
    | '/docs/privacy-policy'
    | '/docs/tos'
    | '/errors/404'
    | '/errors/session-expired'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/orders/upload-failed'
    | '/reconciliation/new'
    | '/reports/oos'
    | '/reports/product-mix'
    | '/reports/sales-by-customer'
    | '/reports/uom-mismatch'
    | '/whatsapp-monitoring/$groupId'
    | '/customers/'
    | '/orders/'
    | '/products/'
    | '/reconciliation/'
    | '/reports/'
    | '/sales-agent/'
    | '/settings/'
    | '/whatsapp-monitoring/'
    | '/orders/generate-invoice/$orderId'
    | '/orders/upload-summary/$requestId'
    | '/products/allocation/upload'
    | '/sales-agent/$agentKey/$sessionId'
    | '/products/allocation/'
    | '/products/upload/'
    | '/reconciliation/$runId/'
    | '/products/upload/review/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/demand-prediction'
    | '/upload-products'
    | '/connect-account'
    | '/docs/privacy-policy'
    | '/docs/tos'
    | '/errors/404'
    | '/errors/session-expired'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/orders/upload-failed'
    | '/reconciliation/new'
    | '/reports/oos'
    | '/reports/product-mix'
    | '/reports/sales-by-customer'
    | '/reports/uom-mismatch'
    | '/whatsapp-monitoring/$groupId'
    | '/customers'
    | '/orders'
    | '/products'
    | '/reconciliation'
    | '/reports'
    | '/sales-agent'
    | '/settings'
    | '/whatsapp-monitoring'
    | '/orders/generate-invoice/$orderId'
    | '/orders/upload-summary/$requestId'
    | '/products/allocation/upload'
    | '/sales-agent/$agentKey/$sessionId'
    | '/products/allocation'
    | '/products/upload'
    | '/reconciliation/$runId'
    | '/products/upload/review/$sessionId'
  id:
    | '__root__'
    | '/_auth'
    | '/_docs'
    | '/_main'
    | '/_onboarding'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_main/about'
    | '/_main/demand-prediction'
    | '/_main/upload-products'
    | '/_onboarding/connect-account'
    | '/_main/'
    | '/_docs/docs/privacy-policy'
    | '/_docs/docs/tos'
    | '/_main/errors/404'
    | '/_main/errors/session-expired'
    | '/_main/orders/$orderId'
    | '/_main/orders/upload'
    | '/_main/orders/upload-failed'
    | '/_main/reconciliation/new'
    | '/_main/reports/oos'
    | '/_main/reports/product-mix'
    | '/_main/reports/sales-by-customer'
    | '/_main/reports/uom-mismatch'
    | '/_main/whatsapp-monitoring/$groupId'
    | '/_main/customers/'
    | '/_main/orders/'
    | '/_main/products/'
    | '/_main/reconciliation/'
    | '/_main/reports/'
    | '/_main/sales-agent/'
    | '/_main/settings/'
    | '/_main/whatsapp-monitoring/'
    | '/_main/orders/generate-invoice/$orderId'
    | '/_main/orders/upload-summary/$requestId'
    | '/_main/products/allocation/upload'
    | '/_main/sales-agent/$agentKey/$sessionId'
    | '/_main/products/allocation/'
    | '/_main/products/upload/'
    | '/_main/reconciliation/$runId/'
    | '/_main/products/upload/review/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DocsRoute: typeof DocsRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_docs': {
      id: '/_docs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_onboarding/connect-account': {
      id: '/_onboarding/connect-account'
      path: '/connect-account'
      fullPath: '/connect-account'
      preLoaderRoute: typeof OnboardingConnectAccountRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_main/upload-products': {
      id: '/_main/upload-products'
      path: '/upload-products'
      fullPath: '/upload-products'
      preLoaderRoute: typeof MainUploadProductsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/demand-prediction': {
      id: '/_main/demand-prediction'
      path: '/demand-prediction'
      fullPath: '/demand-prediction'
      preLoaderRoute: typeof MainDemandPredictionRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/about': {
      id: '/_main/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MainAboutRouteImport
      parentRoute: typeof MainRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_main/whatsapp-monitoring/': {
      id: '/_main/whatsapp-monitoring/'
      path: '/whatsapp-monitoring'
      fullPath: '/whatsapp-monitoring/'
      preLoaderRoute: typeof MainWhatsappMonitoringIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings/': {
      id: '/_main/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof MainSettingsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/sales-agent/': {
      id: '/_main/sales-agent/'
      path: '/sales-agent'
      fullPath: '/sales-agent/'
      preLoaderRoute: typeof MainSalesAgentIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports/': {
      id: '/_main/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof MainReportsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reconciliation/': {
      id: '/_main/reconciliation/'
      path: '/reconciliation'
      fullPath: '/reconciliation/'
      preLoaderRoute: typeof MainReconciliationIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/': {
      id: '/_main/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof MainProductsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/': {
      id: '/_main/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof MainOrdersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/customers/': {
      id: '/_main/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof MainCustomersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/whatsapp-monitoring/$groupId': {
      id: '/_main/whatsapp-monitoring/$groupId'
      path: '/whatsapp-monitoring/$groupId'
      fullPath: '/whatsapp-monitoring/$groupId'
      preLoaderRoute: typeof MainWhatsappMonitoringGroupIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports/uom-mismatch': {
      id: '/_main/reports/uom-mismatch'
      path: '/reports/uom-mismatch'
      fullPath: '/reports/uom-mismatch'
      preLoaderRoute: typeof MainReportsUomMismatchRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports/sales-by-customer': {
      id: '/_main/reports/sales-by-customer'
      path: '/reports/sales-by-customer'
      fullPath: '/reports/sales-by-customer'
      preLoaderRoute: typeof MainReportsSalesByCustomerRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports/product-mix': {
      id: '/_main/reports/product-mix'
      path: '/reports/product-mix'
      fullPath: '/reports/product-mix'
      preLoaderRoute: typeof MainReportsProductMixRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reports/oos': {
      id: '/_main/reports/oos'
      path: '/reports/oos'
      fullPath: '/reports/oos'
      preLoaderRoute: typeof MainReportsOosRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/reconciliation/new': {
      id: '/_main/reconciliation/new'
      path: '/reconciliation/new'
      fullPath: '/reconciliation/new'
      preLoaderRoute: typeof MainReconciliationNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/upload-failed': {
      id: '/_main/orders/upload-failed'
      path: '/orders/upload-failed'
      fullPath: '/orders/upload-failed'
      preLoaderRoute: typeof MainOrdersUploadFailedRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/upload': {
      id: '/_main/orders/upload'
      path: '/orders/upload'
      fullPath: '/orders/upload'
      preLoaderRoute: typeof MainOrdersUploadRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/$orderId': {
      id: '/_main/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof MainOrdersOrderIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/errors/session-expired': {
      id: '/_main/errors/session-expired'
      path: '/errors/session-expired'
      fullPath: '/errors/session-expired'
      preLoaderRoute: typeof MainErrorsSessionExpiredRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/errors/404': {
      id: '/_main/errors/404'
      path: '/errors/404'
      fullPath: '/errors/404'
      preLoaderRoute: typeof MainErrors404RouteImport
      parentRoute: typeof MainRoute
    }
    '/_docs/docs/tos': {
      id: '/_docs/docs/tos'
      path: '/docs/tos'
      fullPath: '/docs/tos'
      preLoaderRoute: typeof DocsDocsTosRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_docs/docs/privacy-policy': {
      id: '/_docs/docs/privacy-policy'
      path: '/docs/privacy-policy'
      fullPath: '/docs/privacy-policy'
      preLoaderRoute: typeof DocsDocsPrivacyPolicyRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_main/reconciliation/$runId/': {
      id: '/_main/reconciliation/$runId/'
      path: '/reconciliation/$runId'
      fullPath: '/reconciliation/$runId/'
      preLoaderRoute: typeof MainReconciliationRunIdIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/upload/': {
      id: '/_main/products/upload/'
      path: '/products/upload'
      fullPath: '/products/upload/'
      preLoaderRoute: typeof MainProductsUploadIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/allocation/': {
      id: '/_main/products/allocation/'
      path: '/products/allocation'
      fullPath: '/products/allocation/'
      preLoaderRoute: typeof MainProductsAllocationIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/sales-agent/$agentKey/$sessionId': {
      id: '/_main/sales-agent/$agentKey/$sessionId'
      path: '/sales-agent/$agentKey/$sessionId'
      fullPath: '/sales-agent/$agentKey/$sessionId'
      preLoaderRoute: typeof MainSalesAgentAgentKeySessionIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/allocation/upload': {
      id: '/_main/products/allocation/upload'
      path: '/products/allocation/upload'
      fullPath: '/products/allocation/upload'
      preLoaderRoute: typeof MainProductsAllocationUploadRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/upload-summary/$requestId': {
      id: '/_main/orders/upload-summary/$requestId'
      path: '/orders/upload-summary/$requestId'
      fullPath: '/orders/upload-summary/$requestId'
      preLoaderRoute: typeof MainOrdersUploadSummaryRequestIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/generate-invoice/$orderId': {
      id: '/_main/orders/generate-invoice/$orderId'
      path: '/orders/generate-invoice/$orderId'
      fullPath: '/orders/generate-invoice/$orderId'
      preLoaderRoute: typeof MainOrdersGenerateInvoiceOrderIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/upload/review/$sessionId': {
      id: '/_main/products/upload/review/$sessionId'
      path: '/products/upload/review/$sessionId'
      fullPath: '/products/upload/review/$sessionId'
      preLoaderRoute: typeof MainProductsUploadReviewSessionIdRouteImport
      parentRoute: typeof MainRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DocsRouteChildren {
  DocsDocsPrivacyPolicyRoute: typeof DocsDocsPrivacyPolicyRoute
  DocsDocsTosRoute: typeof DocsDocsTosRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsDocsPrivacyPolicyRoute: DocsDocsPrivacyPolicyRoute,
  DocsDocsTosRoute: DocsDocsTosRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface MainRouteChildren {
  MainAboutRoute: typeof MainAboutRoute
  MainDemandPredictionRoute: typeof MainDemandPredictionRoute
  MainUploadProductsRoute: typeof MainUploadProductsRoute
  MainIndexRoute: typeof MainIndexRoute
  MainErrors404Route: typeof MainErrors404Route
  MainErrorsSessionExpiredRoute: typeof MainErrorsSessionExpiredRoute
  MainOrdersOrderIdRoute: typeof MainOrdersOrderIdRoute
  MainOrdersUploadRoute: typeof MainOrdersUploadRoute
  MainOrdersUploadFailedRoute: typeof MainOrdersUploadFailedRoute
  MainReconciliationNewRoute: typeof MainReconciliationNewRoute
  MainReportsOosRoute: typeof MainReportsOosRoute
  MainReportsProductMixRoute: typeof MainReportsProductMixRoute
  MainReportsSalesByCustomerRoute: typeof MainReportsSalesByCustomerRoute
  MainReportsUomMismatchRoute: typeof MainReportsUomMismatchRoute
  MainWhatsappMonitoringGroupIdRoute: typeof MainWhatsappMonitoringGroupIdRoute
  MainCustomersIndexRoute: typeof MainCustomersIndexRoute
  MainOrdersIndexRoute: typeof MainOrdersIndexRoute
  MainProductsIndexRoute: typeof MainProductsIndexRoute
  MainReconciliationIndexRoute: typeof MainReconciliationIndexRoute
  MainReportsIndexRoute: typeof MainReportsIndexRoute
  MainSalesAgentIndexRoute: typeof MainSalesAgentIndexRoute
  MainSettingsIndexRoute: typeof MainSettingsIndexRoute
  MainWhatsappMonitoringIndexRoute: typeof MainWhatsappMonitoringIndexRoute
  MainOrdersGenerateInvoiceOrderIdRoute: typeof MainOrdersGenerateInvoiceOrderIdRoute
  MainOrdersUploadSummaryRequestIdRoute: typeof MainOrdersUploadSummaryRequestIdRoute
  MainProductsAllocationUploadRoute: typeof MainProductsAllocationUploadRoute
  MainSalesAgentAgentKeySessionIdRoute: typeof MainSalesAgentAgentKeySessionIdRoute
  MainProductsAllocationIndexRoute: typeof MainProductsAllocationIndexRoute
  MainProductsUploadIndexRoute: typeof MainProductsUploadIndexRoute
  MainReconciliationRunIdIndexRoute: typeof MainReconciliationRunIdIndexRoute
  MainProductsUploadReviewSessionIdRoute: typeof MainProductsUploadReviewSessionIdRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainAboutRoute: MainAboutRoute,
  MainDemandPredictionRoute: MainDemandPredictionRoute,
  MainUploadProductsRoute: MainUploadProductsRoute,
  MainIndexRoute: MainIndexRoute,
  MainErrors404Route: MainErrors404Route,
  MainErrorsSessionExpiredRoute: MainErrorsSessionExpiredRoute,
  MainOrdersOrderIdRoute: MainOrdersOrderIdRoute,
  MainOrdersUploadRoute: MainOrdersUploadRoute,
  MainOrdersUploadFailedRoute: MainOrdersUploadFailedRoute,
  MainReconciliationNewRoute: MainReconciliationNewRoute,
  MainReportsOosRoute: MainReportsOosRoute,
  MainReportsProductMixRoute: MainReportsProductMixRoute,
  MainReportsSalesByCustomerRoute: MainReportsSalesByCustomerRoute,
  MainReportsUomMismatchRoute: MainReportsUomMismatchRoute,
  MainWhatsappMonitoringGroupIdRoute: MainWhatsappMonitoringGroupIdRoute,
  MainCustomersIndexRoute: MainCustomersIndexRoute,
  MainOrdersIndexRoute: MainOrdersIndexRoute,
  MainProductsIndexRoute: MainProductsIndexRoute,
  MainReconciliationIndexRoute: MainReconciliationIndexRoute,
  MainReportsIndexRoute: MainReportsIndexRoute,
  MainSalesAgentIndexRoute: MainSalesAgentIndexRoute,
  MainSettingsIndexRoute: MainSettingsIndexRoute,
  MainWhatsappMonitoringIndexRoute: MainWhatsappMonitoringIndexRoute,
  MainOrdersGenerateInvoiceOrderIdRoute: MainOrdersGenerateInvoiceOrderIdRoute,
  MainOrdersUploadSummaryRequestIdRoute: MainOrdersUploadSummaryRequestIdRoute,
  MainProductsAllocationUploadRoute: MainProductsAllocationUploadRoute,
  MainSalesAgentAgentKeySessionIdRoute: MainSalesAgentAgentKeySessionIdRoute,
  MainProductsAllocationIndexRoute: MainProductsAllocationIndexRoute,
  MainProductsUploadIndexRoute: MainProductsUploadIndexRoute,
  MainReconciliationRunIdIndexRoute: MainReconciliationRunIdIndexRoute,
  MainProductsUploadReviewSessionIdRoute:
    MainProductsUploadReviewSessionIdRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface OnboardingRouteChildren {
  OnboardingConnectAccountRoute: typeof OnboardingConnectAccountRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingConnectAccountRoute: OnboardingConnectAccountRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DocsRoute: DocsRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
